import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DzSelectModule } from '@blk/daisy/combinations/dropdown';
import { DzProgressSpinnerModule } from '@blk/daisy/core/loading';
import { DzButtonModule } from '@blk/daisy/elements/buttons';
import { AdvisoryFeeModule } from '@ddt-web/advisory-fee';
import { AnalyticsModule } from '@ddt-web/analytics';
import { AssetAllocationModule } from '@ddt-web/asset-allocation';
import { SharedModule } from '@ddt-web/common';
import { DataServiceModule } from '@ddt-web/data-service';
import { DcrModule } from '@ddt-web/dcr';
import { DialogModule } from '@ddt-web/dialog';
import { DisclosureModule } from '@ddt-web/disclosure';
import { DomModule } from '@ddt-web/dom';
import { CtaLinkModule } from '@ddt-web/elements';
import { GenericDirectivesModule, GenericPipesModule } from '@ddt-web/generic-utils';
import { AlertsModule } from '@ddt-web/partner-integrations';
import { PerformanceModule } from '@ddt-web/performance';
import { ProposalModule } from '@ddt-web/proposal';

import { HoldingsTableComponent } from './components';
import { HoldingsAnalyticsComponent } from './components/holdings-analytics/holdings-analytics.component';
import { HoldingsTableHeaderComponent } from './components/holdings-table-header';
import { ProxyListOverviewComponent } from './components/proxy-dialog/proxy-list-overview/proxy-list-overview.component';
import { ProxyListItemComponent } from './components/proxy-dialog/proxy-list-overview/proxy-list/proxy-list-item/proxy-list-item.component';
import { ProxyListComponent } from './components/proxy-dialog/proxy-list-overview/proxy-list/proxy-list.component';
import { RiskProxyDialogComponent } from './components/proxy-dialog/risk-proxy-dialog.component';
import { ScrollableHoldingsTableComponent } from './components/scrollable-holdings-table/scrollable-holdings-table.component';
import { EmptyPortfolioDirective } from './directives';

@NgModule({
	declarations: [
		HoldingsTableComponent,
		EmptyPortfolioDirective,
		HoldingsAnalyticsComponent,
		ScrollableHoldingsTableComponent,
		HoldingsTableHeaderComponent,
		RiskProxyDialogComponent,
		ProxyListOverviewComponent,
		ProxyListComponent,
		ProxyListItemComponent
	],
	imports: [
		SharedModule,
		GenericPipesModule,
		DisclosureModule,
		DialogModule,
		AlertsModule,
		AnalyticsModule,
		CwpNgFrameworkModule,
		RouterModule,
		PerformanceModule,
		ProposalModule,
		DcrModule,
		DataServiceModule,
		AssetAllocationModule,
		CtaLinkModule,
		DzButtonModule,
		GenericDirectivesModule,
		DomModule,
		DzProgressSpinnerModule,
		DzSelectModule,
		AdvisoryFeeModule
	],
	exports: [
		HoldingsTableComponent,
		EmptyPortfolioDirective,
		HoldingsAnalyticsComponent,
		ScrollableHoldingsTableComponent,
		HoldingsTableHeaderComponent
	]
})
export class HoldingsModule { }
